import "./NavBar.css";

import { newElement } from "../Dom";
import type { Route } from "../Router";
import Component from "./Component";

export default class NavBar extends Component {

    private routes: Route[] = [];

    public addRoutes(routes: Route[]): this {
        this.routes = routes;
        return this;
    }

    // Køyrer når elementet kjem inn i dokumentet, altså etter addRoutes().
    connectedCallback(): void {
        const navlinkContainer = newElement("nav", { id: "navlinkContainer" });

        for (const route of this.routes) {
            if (route.label === undefined) continue;

            const link = newElement("a", { text: route.label });
            link.href = `#${route.path}`;
            navlinkContainer.appendChild(link);
        }

        const mainContainer = newElement("div", { id: "mainContainer" });
        mainContainer.appendChild(navlinkContainer);

        this.replaceChildren(mainContainer);
    }
}

customElements.define("nav-bar", NavBar);
